import {type ReactAction} from '@netx/core/bootstrap';
import {faArrowsAlt} from '@netx/core-icons';
import {CART_CURRENT_ACTION_LABELS} from '@netx/core-cart-current/locales';
import {CATEGORY_EVENT, OrganizeAssetsAction} from '@netx/core-category-next';
import {canOrganizeAsset} from '../enablers';
import {type IAsset} from '../schema';

/**
 * Move asset to folder
 * @param params
 * @returns Action
 */
export const assetActionCategorizeMove = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-categorize-move',
	cb: () =>
		dispatcher.trigger(CATEGORY_EVENT.SHOW_ORGANIZE_ASSETS, {
			asset,
			action: OrganizeAssetsAction.MOVE,
		}),
	enableTest: () => canOrganizeAsset(asset),
	icon: faArrowsAlt,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE_MOVE;
	},
	...params,
});

export default assetActionCategorizeMove;
